import React from 'react';
import { Card, SvgIcon } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import "./Sidebar.scss";
import CustomizedBadges from './CustomizedBadges';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import AutoCarousel from '../Helpers/Widgets/AutoCarousel/AutoCarousel';
import SideBarCard from '../Common/SideBarCard/SideBarCard';

const useStyles = makeStyles(theme => ({
  sideBar: {
    backgroundColor: theme.palette.primary.main
  }
}));

export default function Sidebar(props) {

  const { navLinks, setActiveNavLink, expanded, onClick } = props;

  return <SidebarView navLinks={navLinks} expanded={expanded} onClick={onClick} setActiveNavLink={setActiveNavLink} />
}

function SidebarView(props) {

  const { navLinks, setActiveNavLink, expanded } = props;

  const links = navLinks.map((item, index) => <SidebarLink
    key={index}
    isActive={item.isActive}
    text={item.text}
    iconElement={<SvgIcon component={item.icon} color="secondary" />}
    link={item.link}
    setActiveNavLink={setActiveNavLink}
    index={index}
    expanded={expanded}
  />);

  let classes = useStyles();
  let sessionStorage = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  let homeTextTestimonials = sessionStorage && sessionStorage.account && sessionStorage.account.homeTextTestimonials;
  let showHomeTextTestimonials = homeTextTestimonials !== null && homeTextTestimonials !== undefined;

  const sideBarCard = showHomeTextTestimonials && homeTextTestimonials.map((v, i) => {
    return (
      <SideBarCard
        name={v.name}
        text={v.text}
        key={i}
      />)
  });

  return (
    <div id={`advisor-sidebar`} className={`${classes.sideBar} ${expanded ? 'advisor-sidebar-expanded' : 'advisor-sidebar-normal'}`}>

      <div id="sidenav-head">
        <img alt="Covr Logo" src={process.env.PUBLIC_URL + "/AdvisorImages/covr-logo-white.svg"} />
        {expanded ? (<SvgIcon component={MenuOpenIcon} className="float-right" onClick={()=>{props.onClick()}} />) : (<SvgIcon component={MenuIcon} onClick={()=>{props.onClick()}} />)}

      </div>

      <div className="sidenav">
        {links}
      </div>

      {/* It will be used in future. */}
      {/* {showHomeTextTestimonials && expanded &&
        <Card className="d-flex flex-column sidebar-card" variant="elevation">
          <AutoCarousel hidePlayButton={true} circleIndicators={true} data={sideBarCard} showCircle={true}/>
        </Card>
      } */}
    </div>
  )
}

function SidebarLink(props) {

  const { link, text, iconElement, isActive, setActiveNavLink, index, expanded } = props;

  return <Link className={isActive ? 'active' : ''} title={(expanded ? '' : text)} onClick={() => setActiveNavLink(index)} to={link}>{iconElement}&nbsp;<span>{expanded ? text : ''}</span>
  <span>{(expanded && link === '/Notifications') ? <CustomizedBadges /> : ''}</span> 
  </Link>;
}


// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar.js